<template>
	<card class="is-card-table has-pagination has-table-borderless has-bottom-left-hidden" title="求人一覧" icon="format-list-bulleted">
		<b-button slot="button" type="is-success" @click="onNewButtonClick">新規作成</b-button>

		<search-bar slot="toolbar" @search="onSearchClick">
			<div class="search-wrap horizontal-center" slot>
				<div class="row">
					<div class="search-type">
						<b-input type="text" placeholder="企業名またはタイトル" v-model="search.word" />
					</div>

					<div class="search-type">
						<div class="search-title">作成日</div>
						<date-picker :dateProvided="search.created" @input="onCreatedInput"></date-picker>
					</div>
				</div>

				<div class="row">
					<div class="search-type">
						<div class="search-title">雇用形態</div>
						<b-select v-model="search.employmentTypeId">
							<option value="">未選択</option>
							<option v-for="(row, index) in employmentTypes" :key="'employmentTypes' + index" :value="row.id">
								{{ row.name }}
							</option>
						</b-select>
					</div>

					<div class="search-type">
						<div class="search-title">業種</div>
						<b-select v-model="search.industryTypeId">
							<option value="">未選択</option>
							<option v-for="(row, index) in industryTypes" :key="'industryTypes' + index" :value="row.id">
								{{ row.name }}
							</option>
						</b-select>
					</div>

					<div class="search-type">
						<div class="search-title">職種</div>
						<b-select v-model="search.occupationTypeId">
							<option value="">未選択</option>
							<option v-for="(row, index) in occupationTypes" :key="'occupationTypes' + index" :value="row.id">
								{{ row.name }}
							</option>
						</b-select>
					</div>
				</div>
			</div>
		</search-bar>

		<b-table
			:loading="isLoading"
			:paginated="true"
			:per-page="$consts.TABLE_PER_PAGE"
			:striped="true"
			:hoverable="true"
			:data="list"
			@page-change="onPageChange"
			>

			<template slot-scope="props">
				<b-table-column label="作成日" field="created" sortable>
					{{ props.row.created }}
				</b-table-column>
				<b-table-column label="会社名" field="company_name" sortable>
					{{ props.row.company_name }}
				</b-table-column>
				<b-table-column label="タイトル" field="title" sortable>
					{{ props.row.title }}
				</b-table-column>
				<b-table-column label="雇用形態" field="employment_type" sortable>
					{{ props.row.employment_type }}
				</b-table-column>
				<b-table-column label="業種" field="industry_type" sortable>
					{{ props.row.industry_type }}
				</b-table-column>
				<b-table-column label="職種" field="occupation_type" sortable>
					{{ props.row.occupation_type }}
				</b-table-column>
				<b-table-column label="公開中" field="is_publish" sortable centered>
					<b-icon type="is-success" icon="check" v-if="props.row.is_publish"></b-icon>
				</b-table-column>
				<b-table-column label=" ">
					<div class="buttons is-right">
						<button class="button is-small is-warning" type="button" @click="$router.push({ name: 'job-edit', params: { jobId: props.row.id }})">編集</button>
						<button class="button is-small is-danger" type="button" @click="onDeleteClick(props.row.id)">削除</button>
					</div>
				</b-table-column>
			</template>

			<section class="section" slot="empty">
				<table-empty :loading="isLoading"></table-empty>
			</section>

			<section class="page-info" slot="bottom-left">
				<page-info :current="currentPage" :data="list"></page-info>
			</section>
		</b-table>
	</card>
</template>

<script>
import qs from 'qs';
import Card from "@/components/Card";
import DatePicker from "@/components/DatePicker";
import SearchBar from "@/components/SearchBar";
import TableEmpty from '@/components/TableEmpty'
import PageInfo from '@/components/PageInfo'

export default {
	name: 'Job',
	components: {
		Card,
		DatePicker,
		SearchBar,
		TableEmpty,
		PageInfo,
	},
	data() {
		return {
			list: [],
			isLoading: false,
			currentPage: 1,
			search: {
				word: '',
				created: '',
				employmentTypeId: '',
				industryTypeId: '',
				occupationTypeId: '',
			},
			occupationTypes: [],
			industryTypes: [],
			employmentTypes: [],
		}
	},
	mounted() {
		this.init();
		this.$store.commit('basic', {
			key: 'titleBarTitleStack',
			value: ['求人管理']
		});
	},
	methods: {
		onDeleteClick: async function(id) {
			if (!window.confirm(this.$consts.MSG_CONFIRM_DELETE)) {
				return false;
			}

			let loading = this.$loading.open();
			let ep = 'jobs/delete';
			this.$utils.log(ep);

			try {
				let res = await this.$api.post(ep, { "id": id }, true);
				this.$utils.log(res);
				this.list.some(function(v, i){
					if (v.id === id) this.list.splice(i, 1);
				}, this);
			} catch (error) {
				this.$utils.log(error);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loading.close();
			}
		},
		onCreatedInput: function(date) {
			this.search.created = date;
		},
		onSearchClick: function() {
			this.getData();
		},
		onNewButtonClick: function() {
			this.$router.push({ name: 'job-new' });
		},
		onSearchButtonClick: function() {
			this.getData();
		},
		init: function() {
			this.getData();
		},
		getData: async function() {
			this.isLoading = true;

			let data = {
				"word": this.search.word,
				"created": this.search.created,
				"employment_type_id": this.search.employmentTypeId,
				"industry_type_id": this.search.industryTypeId,
				"occupation_type_id": this.search.occupationTypeId,
			};

			let ep = 'jobs?' + qs.stringify(data);
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				if (!res.data.list) {
					this.list = [];
				} else {
					this.list = res.data.list;
				}
				this.occupationTypes = res.data.occupation_types;
				this.industryTypes = res.data.industry_types;
				this.employmentTypes = res.data.employment_types;
			} catch (error) {
				this.$utils.log(error);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isLoading = false;
			}
		},
		onPageChange: function(val) {
			this.currentPage = val;
		},
	},
}
</script>

<style lang="scss" scoped>
.searchbar {
	padding-top: 10px !important;
}

.search-wrap {
	flex-wrap: wrap;

	.row {
		display: flex;
		align-items: center;
		margin-top: 20px;

		.search-title {
			margin-right: 10px;
		}
		.search-type {
			display: flex;
			align-items: center;
			margin-right: 30px;
		}
	}
}
</style>
